// extracted by mini-css-extract-plugin
module.exports = {"createGoalFormContainer":"createGoalFormContainer-3ROzI","goalDescription":"goalDescription-IwTP2"};